module.exports = __webpack_public_path__ + "media/images/emblems/Bursins-coat_of_arms-e983817551222b4c715c260462b726af.svg";